module.exports = __webpack_public_path__ + "static/media/centralPark.3a7aec55.jpg";